function gridcarousel(){
  if(typeof quickAddButton == 'function'){
    quickAddButton();
  }
  document.querySelectorAll('.lbo-dots').forEach(function(dotWrapper){
    dotWrapper.querySelectorAll('.lbo-dot').forEach(function(dot){
      dot.addEventListener('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        let thisHandle = dot.getAttribute('data-handle');
        dotWrapper.querySelectorAll('.dot-prod').forEach(function(product){
          let prodHandle = product.getAttribute('data-handle');
          if(prodHandle == thisHandle){
            let dotWrap = product.closest('.lbo-dots-wrap');
            if(dotWrap.classList.contains('active-dot')){
              dotWrap.classList.remove('active-dot');
            }else{
              dotWrapper.querySelectorAll('.lbo-dots-wrap').forEach(function(productRemove){
                productRemove.classList.remove('active-dot');
              });
              dotWrap.classList.add('active-dot');
            }
          }
        });
      });
    });
  });
  document.querySelectorAll('.snippet-promo-image.desk-promo').forEach((promo) => {
    let prev = promo.previousSibling;
    promo.style.height = 'calc(100% - '+prev.querySelector('.grid-meta').clientHeight+'px)';
  })
  document.querySelectorAll('.metafield-colors li').forEach((color) => {
    color.addEventListener('mouseover',function(){
      const productGrid = color.closest('.snippet-product-grid');
      if(!productGrid) return;
      
      // Skip the first/active swatch since it's already in the slider
      if(color.classList.contains('active')) return;
      
      const dataImage = color.getAttribute('data-image');
      const slider = productGrid.querySelector('.product-images-slider');
      
      if(dataImage && slider){
        const slides = slider.querySelectorAll('.product-image-slide');
        const firstSlide = slides[0];
        const firstImg = firstSlide?.querySelector('img');
        
        // Hide all other slides first
        slides.forEach((slide, index) => {
          if(index > 0) slide.style.display = 'none';
        });
        
        // Then reset scroll position (won't be visible since slides are hidden)
        slider.scrollLeft = 0;
        
        if(firstImg){
          // Then replace the src of the first image
          firstImg.src = dataImage;
          firstImg.srcset = dataImage;
        }
        
        // Hide slider arrows
        const arrows = productGrid.querySelectorAll('.slider-arrow');
        arrows.forEach(arrow => arrow.style.display = 'none');
      }
      
      // Update prices
      if(color.getAttribute('data-price')){
        productGrid.querySelector('.grid-meta .regular-price').textContent = color.getAttribute('data-price');
      }
      if(color.getAttribute('data-compare-price')){
        productGrid.querySelector('.grid-meta .compare-price').textContent = color.getAttribute('data-compare-price');
      }
    })
    
    color.addEventListener('mouseout',function(){
      const productGrid = color.closest('.snippet-product-grid');
      if(!productGrid) return;
      
      // Skip the first/active swatch
      if(color.classList.contains('active')) return;
      
      const activeColor = color.closest('.metafield-colors').querySelector('li.active');
      const slider = productGrid.querySelector('.product-images-slider');
      
      if(slider){
        const slides = slider.querySelectorAll('.product-image-slide');
        const firstSlide = slides[0];
        const firstImg = firstSlide?.querySelector('img');
        
        // Restore original image from active color
        if(firstImg && activeColor){
          const activeDataImage = activeColor.getAttribute('data-image');
          if(activeDataImage){
            firstImg.src = activeDataImage;
            firstImg.srcset = activeDataImage;
          }
        }
        
        // Reset scroll position to start
        slider.scrollLeft = 0;
        
        // Show all slides again
        slides.forEach(slide => {
          slide.style.display = '';
        });
        
        // Show slider arrows if there are multiple items
        const totalItems = parseInt(slider.dataset.sliderItems) || 1;
        if(totalItems > 1){
          const arrows = productGrid.querySelectorAll('.slider-arrow');
          arrows.forEach(arrow => arrow.style.display = '');
          
          // Update arrow states after scroll reset
          const prevBtn = productGrid.querySelector('.slider-arrow-prev');
          const nextBtn = productGrid.querySelector('.slider-arrow-next');
          if(prevBtn) prevBtn.classList.add('disabled');
          if(nextBtn) nextBtn.classList.remove('disabled');
        }
      }
      
      // Restore original prices
      if(activeColor){
        if(activeColor.getAttribute('data-price')){
          productGrid.querySelector('.grid-meta-price .regular-price').textContent = activeColor.getAttribute('data-price');
        }
        if(activeColor.getAttribute('data-compare-price')){
          productGrid.querySelector('.grid-meta-price .compare-price').textContent = activeColor.getAttribute('data-compare-price');
        }
      }
    })
  })
}
setTimeout(function(){
  gridcarousel();
  window.addEventListener("resize", gridcarousel);
},500)
var advance = function() {
  if (typeof removeDuplicateProductItems === 'function') removeDuplicateProductItems();
  gridcarousel();
  if(typeof initProductGridSliders == 'function'){
    initProductGridSliders();
  }
}
// var infinitescroll = {
//   scolljs: function(){
//     var endlessScroll = new Ajaxinate({
//       container: '#product-grid',
//       pagination: '#load-more',
//       callback: advance,
//       offset:1000
//     });
//   }
// }
// infinitescroll.scolljs();
var infinitescroll = {
  scolljs: function(){
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#load-more',
      //loadingText: document.getElementById('AjaxinatePagination').dataset.text,
      callback: advance,
      //offset: 200
    });
  }
}
infinitescroll.scolljs();
document.addEventListener('scroll', function(e) {
  var totalpage = document.querySelector('#load-more a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
  sessionStorage.scrollPos = document.documentElement.scrollTop;
  sessionStorage.totalpage = totalpage;
});
// if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
//   var scrollTop=sessionStorage?.getItem('scrollPos')
//   document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
//   window.scrollTo(0,0);
//   scrollManualy(scrollTop);
//   function scrollManualy(scrollTop){
//       scrollTop = parseInt(scrollTop);
//       window.scrollTo(0,scrollTop)
//       setTimeout(function(){
//           if(window.scrollY < scrollTop){
//               scrollManualy(scrollTop)
//           }
//       },1000);
//    }
// }
// document.addEventListener('scroll', function(e) {
//   var totalpage = document.querySelector('#load-more a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
//   sessionStorage.scrollPos = document.documentElement.scrollTop;
//   sessionStorage.totalpage = totalpage;
// });
// if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
//   var scrollTop = sessionStorage?.getItem('scrollPos');
//   var buttonTop = document.querySelector('#load-more');
//   var buttonScroll = buttonTop.offsetTop - window.scrollY;
//   document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
//   if(buttonScroll < scrollTop){
//     var buttonScroll = buttonTop.offsetTop - window.scrollY ;
//     scrollManualy(buttonScroll);
//   }else{
//      scrollManualy(scrollTop);
//   }
//   function scrollManualy(scrollTop1){
//     scrollTop1 = parseInt(scrollTop1);
//     window.scrollTo(0,scrollTop1)
//     setTimeout(function(){
//       if(buttonScroll < scrollTop){
//       buttonScroll = buttonTop.offsetTop ;
//         scrollManualy(buttonScroll);
//       } else {
//         window.scrollTo(0,scrollTop)
//         return false;
//       }
//     },500);
//   }
// }
if(document.querySelectorAll('.snippet-promo-image.desk-promo')) document.querySelectorAll('.snippet-promo-image.desk-promo').forEach((promo) => {
  setTimeout(() => {
    let prev = promo.previousSibling;
    promo.style.height = 'calc(100% - '+prev.querySelector('.grid-meta').clientHeight+'px)';
  }, 800);
})

document.addEventListener('DOMContentLoaded', function () {

  const sortItems = document.querySelectorAll('.sort-item');
  const radios = document.querySelectorAll('input[name="sort_by"]');

  const resetAll = () => {
    sortItems.forEach(el => el.classList.remove('active'));
  };

  sortItems.forEach(item => {
    item.addEventListener('click', function () {
      const sortId = this.dataset.id;
      const radio = document.querySelector(`input[name="sort_by"][id="${sortId}"]`);

      if (!radio) return;

      radio.click();

      resetAll();
      this.classList.add('active');
    });
  });

  radios.forEach(radio => {
    radio.addEventListener('change', function () {
      if (!this.checked) return;

      resetAll();
      const activeItem = document.querySelector(`.sort-item[data-id="${this.id}"]`);
      if (activeItem) activeItem.classList.add('active');
    });
  });

  const checkedRadio = document.querySelector('input[name="sort_by"]:checked');
  if (checkedRadio) {
    const activeItem = document.querySelector(`.sort-item[data-id="${checkedRadio.id}"]`);
    if (activeItem) activeItem.classList.add('active');
  }

});
document.addEventListener('click', function (e) {
  const sortButton = e.target.closest('.sort');
  if (!sortButton) return;

  document.body.classList.toggle('show-sort');
  document.body.classList.remove('open-category');
});

const collCount = document.querySelector('.coll-count');

if (collCount) {
  collCount.addEventListener('click', function() {
    document.body.classList.toggle('open-category');
    document.body.classList.remove('show-sort');
  });
}


(() => {
  const nav = document.querySelector('.snippet-collection-navigation');
  if (!nav) return;

  const allLi = nav.querySelector('li:not(.back-to-all):not([data-type])');
  const items = nav.querySelectorAll('li[data-type]');
  const params = new URLSearchParams(window.location.search);

  let currentType = params.get('filter.p.product_type') || '';

  const setActive = () => {
    nav.querySelectorAll('li.active').forEach(li => li.classList.remove('active'));
    if (!currentType && allLi) return allLi.classList.add('active');

    const lowerType = currentType.trim().toLowerCase();
    for (const li of items) {
      if (li.dataset.type.trim().toLowerCase() === lowerType) {
        li.classList.add('active');
        return;
      }
    }
    if (allLi) allLi.classList.add('active');
  };

  setActive();
  window.addEventListener('popstate', setActive);

  nav.addEventListener('click', e => {
    const li = e.target.closest('li[data-type]');
    if (!li) return;
    nav.querySelectorAll('li.active').forEach(l => l.classList.remove('active'));
    li.classList.add('active');
  });
})();


document.addEventListener('DOMContentLoaded', function() {
  const filterHead = document.querySelector('.filter-head');
  const footer = document.querySelector('.footer');
  
  if (!filterHead || !footer) return;
  
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        // Hide when any part of footer enters viewport
        if (entry.isIntersecting) {
          filterHead.style.display = 'none';
        } else {
          filterHead.style.display = '';
        }
      });
    },
    {
      threshold: 0,
      rootMargin: '100px 0px 0px 0px' // Trigger 100px before footer reaches viewport
    }
  );
  
  observer.observe(footer);
});